export const SET_PRODUCT_TYPE_LIST = "SET_PRODUCT_TYPE_LIST";
export const SET_MATERIAL_MODAL = "SET_MATERIAL_MODAL";
export const SET_MATERIAL_SELECTED = "SET_MATERIAL_SELECTED";
export const ADD_MATERIAL_TO_SLOT = "ADD_MATERIAL_TO_SLOT";
export const REMOVE_MATERIAL_FROM_SLOT = "REMOVE_MATERIAL_FROM_SLOT";
export const RESET_COMPARE_SLOTS = "RESET_COMPARE_SLOTS";
export const CLEAR_MATERIAL_SELECTED = 'CLEAR_MATERIAL_SELECTED';
export const SET_MATERIAL_SELECTED_FROM_ARCHIVE = 'SET_MATERIAL_SELECTED_FROM_ARCHIVE';